import { Theme } from "@mui/material";
import { gray } from "../themePrimitives";

export const border = (theme: Theme) => '.5px solid ' + (theme.palette.mode === 'dark' ? gray[700] : gray[500])
export const TEXT_SHADOW = `
0.5px 0.5px 0 rgb(0 0 0 / 2%),
-0.5px 0.5px 0 rgb(0 0 0 / 2%),
0.5px -0.5px 0 rgb(0 0 0 / 2%),
-0.5px -0.5px 0 rgb(0 0 0 / 2%),
0px 0.5px 0 rgb(0 0 0 / 2%),
0px -0.5px 0 rgb(0 0 0 / 2%),
-0.5px 0px 0 rgb(0 0 0 / 2%),
0.5px 0px 0 rgb(0 0 0 / 2%),
0.5px 0.5px 0 rgb(0 0 0 / 2%),
-0.5px 0.5px 0 rgb(0 0 0 / 2%),
0.5px -0.5px 0 rgb(0 0 0 / 2%),
-0.5px -0.5px 0 rgb(0 0 0 / 2%),
0px 0.5px 0 rgb(0 0 0 / 2%),
0px -0.5px 0 rgb(0 0 0 / 2%),
-0.5px 0px 0 rgb(0 0 0 / 2%),
0.5px 0px 0 rgb(0 0 0 / 2%),
0.5px 0.5px 0 rgb(0 0 0 / 2%),
-0.5px 0.5px 0 rgb(0 0 0 / 2%),
0.5px -0.5px 0 rgb(0 0 0 / 2%),
-0.5px -0.5px 0 rgb(0 0 0 / 2%),
0.5px 0.5px 0 rgb(0 0 0 / 2%),
-0.5px 0.5px 0 rgb(0 0 0 / 2%),
0.5px -0.5px 0 rgb(0 0 0 / 2%),
-0.5px -0.5px 0 rgb(0 0 0 / 2%)
`